import { createLazyComponent, LazyModule, LazyAction, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CollabSpace" */ './lazyIndex')
);
export const CollabSpace = createLazyComponent(lazyModule, m => m.CollabSpace);
export const CollabSpaceInlineFeedback = createLazyComponent(
    lazyModule,
    m => m.CollabSpaceInlineFeedback
);
export const CollabSpaceBlockDialog = createLazyComponent(
    lazyModule,
    m => m.CollabSpaceBlockDialog
);
export const lazyUpdateCalendarEventCollabSpace = new LazyAction(
    lazyModule,
    m => m.updateCalendarEventCollabSpace
);
export const lazyIsRendered = new LazyAction(lazyModule, m => m.isRendered);
export const lazyIsEnabled = new LazyAction(lazyModule, m => m.isEnabled);
export const lazyHasFluidLinkFailed = new LazyAction(lazyModule, m => m.hasFluidLinkFailed);
export const lazyGetShareLink = new LazyAction(lazyModule, m => m.getShareLink);
export const lazyIsCollabSpaceExplicitlyDisabled = new LazyAction(
    lazyModule,
    m => m.isCollabSpaceExplicitlyDisabled
);
export const lazyGetConfirmationOptions = new LazyImport(lazyModule, m => m.getConfirmationOptions);
export const lazyInitializeStore = new LazyAction(lazyModule, m => m.initializeStore);
export const lazyRemoveCollabSpaceViewStateFromCollection = new LazyAction(
    lazyModule,
    m => m.removeViewStateFromCollection
);
export const lazyGetCreationSource = new LazyAction(lazyModule, m => m.getCreationSource);

export { isEventFromDifferentMailbox } from './utils/isEventFromDifferentMailbox';
export { createCollabSpaceViewStateId } from './utils/createCollabSpaceViewStateId';
